import React, {useState} from 'react';
import LimitedTouchAreaButton from "./limitedTouchAreaButton";
import experimentState from "./state/experimentState";
import backend from "./backend";
import {observer} from "mobx-react";
import themeState from "./state/themeState";
import $ from "jquery";
import fakePointerRegister from "./state/fakePointerRegister";

class AdminPanel extends React.Component {
    text_area_key = "chat_panel_text_area"

    constructor(props) {
        super(props);
        this.initialState = {
            message: "",
            placeholder: true,
        }
        this.state = this.initialState
        this.messageBuffer = []
        this.messageBufferPointer = 0;
        this.myRef = React.createRef();
        this.messageTickIntervalRef = null;
    }

    componentDidMount() {
        // fakePointerRegister.register(this.text_area_key,this.fakeOnClick.bind(this))

    }

    componentWillUnmount() {
        // fakePointerRegister.unregister(this.text_area_key)
    }

    render() {
        return <div>
            <p>Questions finished: {experimentState.questionsFinished}</p>
            <p>expired: {experimentState.questionsExpired}</p>
        </div>;
    }

}

AdminPanel = observer(AdminPanel);


export default AdminPanel;